// Utility to clean up any conflicting session data
export const cleanupOldSessionData = () => {
  try {
    // List of potential old storage keys that might conflict
    const keysToRemove = [
      // Old supabase auth keys
      'supabase.auth.token',
      'sb-mbppphoddpitkedffmao-auth-token',
      'sb-vchhpkwaysrjrhlllpvt-auth-token', // from zipBoundariesClient
      // Any other variations that might exist
    ];

    // Clean up localStorage
    keysToRemove.forEach(key => {
      if (localStorage.getItem(key)) {
        console.log(`Removing old session key: ${key}`);
        localStorage.removeItem(key);
      }
    });

    // Clean up sessionStorage
    keysToRemove.forEach(key => {
      if (sessionStorage.getItem(key)) {
        console.log(`Removing old session key from sessionStorage: ${key}`);
        sessionStorage.removeItem(key);
      }
    });

    console.log('Session cleanup completed');
  } catch (error) {
    console.error('Error during session cleanup:', error);
  }
};

// Function to check for multiple auth instances and clean them up
export const detectAndCleanupMultipleAuthInstances = () => {
  try {
    // Check for signs of multiple auth instances
    const allKeys = Object.keys(localStorage);
    const authKeys = allKeys.filter(key => 
      key.includes('supabase') || 
      key.includes('auth') || 
      key.includes('sb-')
    );

    if (authKeys.length > 2) { // More than business_type and savants-auth
      console.warn('Multiple auth keys detected:', authKeys);
      console.log('Cleaning up potentially conflicting keys...');

      // Keep only the keys we want
      const keysToKeep = ['business_type', 'businessType', 'savants-auth'];

      authKeys.forEach(key => {
        if (!keysToKeep.includes(key) && !key.includes('savants-auth')) {
          console.log(`Removing potentially conflicting key: ${key}`);
          localStorage.removeItem(key);
        }
      });
    }
  } catch (error) {
    console.error('Error detecting multiple auth instances:', error);
  }
}; 